/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const QuestionmarkOutlineIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, d: "M12 15a1 1 0 100 2 1 1 0 000-2zm-1.765-7.389a2.868 2.868 0 012.463-0.527c1.269 0.305 2.155 1.456 2.155 2.799 0 0.844-0.4 1.611-1.072 2.076l-0.556 0.385a1.103 1.103 0 00-0.475 0.906 0.75 0.75 0 11-1.5 0 2.604 2.604 0 011.121-2.14l0.556-0.384a0.994 0.994 0 000.426-0.819c0-0.66-0.423-1.225-1.006-1.365a1.36 1.36 0 00-1.183 0.247 1.347 1.347 0 00-0.517 1.064 0.75 0.75 0 01-1.5 0 2.84 2.84 0 011.088-2.242z" }),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 3a9 9 0 100 18 9 9 0 000-18zm0 16.5c-4.136 0-7.5-3.364-7.5-7.5S7.864 4.5 12 4.5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5z", clipRule: "evenodd" })));
};
//# sourceMappingURL=QuestionmarkOutlineIcon.js.map